export const getUrlData = (url) => {
  let splitPathname = url.split('/');

  let omsId = splitPathname?.[3];

  const configuratorPath = ['custom-countertops', 'countertops', 'configurator'].join('|');
  const isConfiguratorPath = new RegExp(configuratorPath).test(splitPathname);

  if (isConfiguratorPath) {
    omsId = splitPathname?.[4];
  }

  if (splitPathname.includes('render-nucleus') || splitPathname.includes('render-internal')) {
    omsId = splitPathname?.[4];

    if (isConfiguratorPath) {
      omsId = splitPathname?.[5];
    }
  }

  return { omsId };
};

export const getPageDataServer = async (system, omsId) => {
  // Validate that omsId is numeric
  if (!omsId || !/^\d+$/.test(omsId)) {
    return {
      config: { omsId, errorMessage: 'Invalid OMS ID - must be numeric' },
      product: { details: {} },
    };
  }

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  const baseApiPath = system.expConfiguration['countertops-base-api-url'];
  let dataObject;

  try {
    const response = await system.fetch(
      `${baseApiPath}/countertops/pagedata/${omsId}`,
      requestOptions
    );
    if (response) {
      return response;
    }
    dataObject = {
      config: { omsId },
      product: { details: {} },
    };
  } catch (error) {
    dataObject = {
      config: { omsId, errorMessage: error },
      product: { details: {} },
    };
  }

  return dataObject;
};

export const getDataObject = async (system, omsId) => {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  const baseApiPath = system.expConfiguration['countertops-base-api-url'];
  let dataObject;

  /* This is for local dev if call is down */
  // return dataObject = mockData;

  // https://stage-custom.hd-qa74.homedepotdev.com/pipfigurator/PageData/api/v1/320340139
  try {
    const response = await system.fetch(
      `${baseApiPath}/pipfigurator/PageData/api/v1/${omsId}`,
      requestOptions
    );
    if (response) {
      dataObject = {
        config: {
          ...response.settings,
          title: response.meta.title,
          pageDescription: response.meta.pageDescription,
          categoryName: response.meta.categoryName,
          siteName: response.meta.siteName,
          breadcrumbs: response.thdBreadcrumbInfo.thdBreadcrumbs,
          isAddtoBundleDisabled: false,
          isCopy: false,
          omsId,
        },
        product: {
          details: { ...response.product },
        },
      };
    } else {
      dataObject = {
        config: { omsId },
        product: { details: {} },
      };
    }
  } catch (error) {
    dataObject = {
      config: { omsId, errorMessage: error },
      product: { details: {} },
    };
  }

  return dataObject;
};

export const getGalleryData = async (system, dataObject) => {
  const baseApiPath = system.expConfiguration['base-api-url'];
  const folder = dataObject?.product?.details?.attributes?.scene7Folder;
  const omsId = dataObject?.product?.details?.productId;

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  const fetchUrl = `${baseApiPath}/pipfigurator/api/gallery?folder=${folder}&omsId=${omsId}_`;

  let galleryData;

  const response = await system.fetch(fetchUrl, requestOptions);

  if (response) {
    galleryData = response;
  } else {
    galleryData = {
      error: { errorMessage: JSON.stringify(response), fetchUrl },
    };
  }

  return galleryData;
};

export const theme = {
  scheme: 'nucleus',
};
